var locale = {
  placeholder: 'Select time'
};
export default locale;
//# sourceMappingURL=en_US.js.map
